'use client';

import { Button } from '@/comps/primitives/button';
import {
  PARAMS_KEY_ORGANIZATION_ID,
  PARAMS_KEY_PROJECT_ID,
} from '@/constants/route-params-keys';
import {
  useCanAccessAdminPanel,
  useDefaultAdminPanelSection,
} from '@/domains/admin-panel/use-admin-panel-sidebar-items';
import { useAppNavigation } from '@/domains/navigation/use-app-navigation';
import { usePathname } from 'next/navigation';

export function AppShellAdminPanelButton() {
  const pathname = usePathname();
  const { navigateApp } = useAppNavigation();
  const canAccessAdminPanel = useCanAccessAdminPanel();
  const defaultSection = useDefaultAdminPanelSection();
  const isActive = pathname.startsWith('/admin-panel');

  if (!canAccessAdminPanel) return null;

  return (
    <Button
      size="sm"
      variant="outline"
      className="h-7 px-2.5 text-xs"
      aria-current={isActive ? 'page' : undefined}
      onClick={() => {
        navigateApp({
          route: 'admin-panel-section',
          section: defaultSection,
          keepList: [PARAMS_KEY_ORGANIZATION_ID, PARAMS_KEY_PROJECT_ID],
        });
      }}
    >
      Admin panel
    </Button>
  );
}
